import { createRoutine } from 'redux-saga-routines';

export const fetchUsersRoutine = createRoutine('FETCH_USERS');
export const changeUserRoleRoutine = createRoutine('CHANGE_USER_ROLE');
export const changeUserStatusRoutine = createRoutine('CHANGE_USER_STATUS');
export const changeUserTeamRoutine = createRoutine('CHANGE_USER_TEAM');
export const changeUsersTeamRoutine = createRoutine('CHANGE_USERS_TEAM');
export const changeUsersRoleRoutine = createRoutine('CHANGE_USERS_ROLE');
export const createUserRoutine = createRoutine('CREATE_USER');
export const setCreateUserErrorRoutine = createRoutine('SET_CREATE_USER_ERROR');
export const resendInviteRoutine = createRoutine('RESEND_INVITE');
export const changeUsersStatusRoutine = createRoutine('CHANGE_USERS_STATUS');

export const updateProfileRoutine = createRoutine('UPDATE_PROFILE');
export const setUpdateProfileErrorRoutine = createRoutine('SET_UPDATE_PROFILE_ERROR');

export const fetchEmailTemplatesRoutine = createRoutine('FETCH_EMAIL_TEMPLATES');
export const createEmailTemplateRoutine = createRoutine('CREATE_EMAIL_TEMPLATE');
export const updateEmailTemplateRoutine = createRoutine('UPDATE_EMAIL_TEMPLATE');
export const getCandidateTemplateCodeRoutine = createRoutine('GET_CANDIDATE_TEMPLATE_CODE');
export const getReferenceTemplateCodeRoutine = createRoutine('GET_REFERENCE_TEMPLATE_CODE');

export const getApiTokensRoutine = createRoutine('GET_API_TOKENS');
export const createApiTokenRoutine = createRoutine('CREATE_API_TOKEN');
export const reactivateApiTokenRoutine = createRoutine('REACTIVATE_API_TOKEN');
export const deactivateApiTokenRoutine = createRoutine('DEACTIVATE_API_TOKEN');
export const deleteApiTokenRoutine = createRoutine('DELETE_API_TOKEN');
export const resetApiTokenRoutine = createRoutine('RESET_API_TOKEN');

export const updateDefaultCountersRoutine = createRoutine('UPDATE_DEFAULT_COUNTERS');

export const getIntegrationsDataRoutine = createRoutine('GET_INTEGRATIONS_DATA');
export const disconnectFromLeverRoutine = createRoutine('DISCONNECT_FROM_LEVER');
export const getLeverStagesRoutine = createRoutine('GET_LEVER_STAGES');
export const getSurveyNamesRoutine = createRoutine('GET_SURVEYS_NAMES');
export const setLeverStageRoutine = createRoutine('SET_LEVER_STAGE');
export const setLeverSurveyRoutine = createRoutine('SET_LEVER_SURVEY');
